import { getPaymentOptionTypeFromId } from "./Button/logic/utils";
// Filters the payments based on allowed methods
export var filterPayments = function filterPayments(payments, allowedMethods) {
  return payments.filter(function (_ref) {
    var id = _ref.id;
    var paymentType = getPaymentOptionTypeFromId(id !== null && id !== void 0 ? id : '');
    return paymentType && allowedMethods.includes(paymentType);
  }).filter(Boolean);
};